import React from 'react';

export const getOption = value => ({ value: value || '', label: value });
export const getOptions = values => values.map(getOption);
export const mapId = item => item.id;
export const mapName = item => item.name;

export const formInputStyles = {
  control: base => ({
    ...base,
    'min-height': 34,
    'margin-bottom': 4
  })
};

export const inlineStyles = {
  control: base => ({
    ...base,
    borderColor: '#e4e4e4',
    minHeight: 30,
  }),

  indicatorsContainer: base => ({
    ...base,
    marginTop: -8,
    marginBottom: -8,
  }),

  placeholder: base => ({
    ...base,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
};

export const horizontalFormStyles = applyStyleOverrides(inlineStyles, {
  control: {
    height: 28,
    minHeight: 28,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },

  valueContainer: {
    height: 26,
    paddingTop: 0,
  },
});

export function applyStyleOverrides(styles, overrides = {}) {
  styles = { ...styles };

  for (const key in overrides) {
    if (styles[key]) {
      const baseFn = styles[key];
      styles[key] = base => ({
        ...baseFn(base),
        ...overrides[key]
      });
    } else {
      styles[key] = base => ({
        ...base,
        ...overrides[key]
      });
    }
  }

  return styles;
}

export function getInlineStyles(overrides = {}) {
  return applyStyleOverrides(inlineStyles, overrides);
}

export function getHorizontalFormStyles(options = {}) {
  const overrides = options.overrides || {};
  if (options.error) {
    // TODO: How to share colors between JS CSS and our SCSS variables?
    overrides.control = { ...overrides.control, 'border-color': '#f97979' };
  }

  return applyStyleOverrides(horizontalFormStyles, overrides);
}

export const unclearableMultiValueComponents = {
  MultiValueRemove() {
    return <span>&nbsp;</span>;
  }
};

export function getPortaledMenuProps(styles = {}) {
  return {
    menuPortalTarget: document.body,
    styles: {
      ...styles,
      menuPortal: base => ({ ...base, 'z-index': '9999' })
    }
  };
}
